import { ScrollingModule } from '@angular/cdk/scrolling'
import { VirtualScrollViewportDirective } from 'src/services/table-utils/virtual-scroll-viewport.directive'
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatDividerModule } from '@angular/material/divider'
import { MatIconModule } from '@angular/material/icon'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatTableModule } from '@angular/material/table'
import { MatTooltipModule } from '@angular/material/tooltip'
import { RouterModule } from '@angular/router'
import { PipesModule } from 'src/shared/pipes/pipes.module'
import { TypeSafeMatCellDefModule } from '../type-safe-mat-cell-def/type-safe-mat-cell-def.module'
import { PathsListComponent } from './paths-list.component'
import { MatRadioModule } from '@angular/material/radio'

@NgModule({
  declarations: [PathsListComponent],
  exports: [PathsListComponent],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatPaginatorModule,
    MatRadioModule,
    MatTableModule,
    MatTooltipModule,
    ScrollingModule,
    VirtualScrollViewportDirective,
    PipesModule,
    TypeSafeMatCellDefModule,
  ],
})
export class PathsListModule { }
